import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      // Not bg-accent (oklch 0.97): the admin content area's canvas is 0.975, so a skeleton drawn straight
      // on the page, not in a card, vanished. The foreground at 6% reads on the canvas and on a white card.
      className={cn("animate-pulse rounded-md bg-foreground/6 dark:bg-accent", className)}
      {...props}
    />
  )
}

export { Skeleton }
